import { render, staticRenderFns } from "./purchase-project-detail.html?vue&type=template&id=4b9919a1&scoped=true&external"
import script from "./purchase-project-detail.js?vue&type=script&lang=js&external"
export * from "./purchase-project-detail.js?vue&type=script&lang=js&external"
import style0 from "./purchase-project-detail.scss?vue&type=style&index=0&id=4b9919a1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9919a1",
  null
  
)

export default component.exports